import type { Currency } from '@fv/models'
import { parseCurrency as _parseCurrency } from '@fv/models/core'

export const parseCurrency = _parseCurrency

export const currencyToString = (
  value: number,
  includeEmptyDecimals = false,
) => {
  const str = value.toFixed(2)
  if (str.endsWith('.00') && !includeEmptyDecimals) return value.toString()
  return str
}

const emptyDecimalRegex = /\.00$/
type FormatterOpts = {
  currency?: Currency
  includeEmptyDecimals?: boolean
  precision?: number
}
export const useNumberFormatter = ({
  currency,
  includeEmptyDecimals,
  precision = 2,
}: FormatterOpts) => {
  // TODO - replace with locale & currency as we expand
  const formatter = new Intl.NumberFormat('en-US', {
    style: currency ? 'currency' : 'decimal',
    ...((includeEmptyDecimals || precision === 0) && {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    }),
    ...(currency && {
      currency: currency.toUpperCase(),
      currencyDisplay: 'narrowSymbol',
    }),
  })
  return (val: number | string) => {
    const formatted = formatter.format(parseFloat(val.toString()))
    if (formatted.endsWith('.00') && !includeEmptyDecimals) {
      return formatted.replace(emptyDecimalRegex, '')
    }
    return formatted
  }
}
